export default {
  'environment': 'production',
  'basePath': window.location.protocol + '//api.forms.cliqforms.io/api',
  'recaptchaSiteKey': '6Lc_gVYsAAAAANsifXfjHBTeLEiVVC8X8xDWAOWe',
  'formsUrl': window.location.protocol + '//form.cliqforms.io',
  'proofsUrl': window.location.protocol + '//proofs.forms.cliqforms.io',
  'scriptsUrl': window.location.protocol + '//scripts.forms.cliqforms.io',
  'qrUrl': window.location.protocol + '//qr.cliqforms.io',
  'sampleCsvUrl': window.location.protocol + '//' + window.location.host + '/static/sample/SampleTemplate.csv',
  'paddle': {
    'vendorId': 111484,
    'trialPlanId': 638341,
    'trialScaleId': 787251,
    'trialEnterpriseId': 787252,
    'trialAnnualProId': 787253,
    'trialAnnualScaleId': 787254,
    'trialAnnualEnterpriseId': 787256,
    'starterPlanId': 889848,
    'planId': 589934,
    'scaleId': 638342,
    'enterpriseId': 768477,
    'annualProId': 740474,
    'annualScaleId': 740472,
    'annualEnterpriseId': 768479,
    'singlePlanId': 805791,
    'bronzeMonthlyId': 919460,
    'bronzeYearlyId': 919461,
    'silverMonthlyId': 919462,
    'silverYearlyId': 919463,
    'goldMonthlyId': 919464,
    'goldYearlyId': 919465
  },
  'registration': {
    'recaptchaEnabled': true
  }
}
